import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useGlobal } from '@/utils/useGlobal';
import EcoImg from 'eco-design/base/eco-img';
import EcoSpace from 'eco-design/base/eco-space';
import style from './index.module.scss';

interface Props {
    endTime?: number;
}

const Comp: React.FC<Props> = ({ endTime }) => {
    const { getSystemTime, useRouter } = useGlobal();
    const router = useRouter();
    const { t } = useLang('theProduct.EarlyBirdOffer');
    const { locale } = getLocal();

    let systemTime = getSystemTime();
    const { _timer } = router.query;
    if (_timer) {
        systemTime = new Date(_timer).getTime();
    }
    if (endTime && systemTime >= endTime) return null;
    return (
        <div
            className={`${style.comp} GtmModuleData-section`}
            id="EarlyBirdOffer"
            data-section-id="EarlyBirdOffer"
            data-section-title={t('title') || t('module-title')}
        >
            <EcoSpace />
            <div className="box">
                <div className="info">
                    <div className="title">{t('title')}</div>
                    <div className="desc">
                        {t.rich('desc', {
                            h: (v: string) => <span>{v}</span>,
                        })}
                    </div>
                </div>
                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1755488860998/EarlyBirdOffer.png" />
            </div>
        </div>
    );
};

export default Comp;
